
/**
 * Convierte un número a su representación en palabras en español.
 * Soporta números hasta 999.999.999 (aunque para la UI de grilla usualmente es menor).
 */
export const numberToWords = (num: number): string => {
  if (num === 0) return "cero";

  const unidades = [
    "",
    "un",
    "dos",
    "tres",
    "cuatro",
    "cinco",
    "seis",
    "siete",
    "ocho",
    "nueve",
  ];
  const especiales = [
    "diez",
    "once",
    "doce",
    "trece",
    "catorce",
    "quince",
    "dieciséis",
    "diecisiete",
    "dieciocho",
    "diecinueve",
  ];
  const decenas = [
    "",
    "diez",
    "veinte",
    "treinta",
    "cuarenta",
    "cincuenta",
    "sesenta",
    "setenta",
    "ochenta",
    "noventa",
  ];
  const centenas = [
    "",
    "ciento",
    "doscientos",
    "trescientos",
    "cuatrocientos",
    "quinientos",
    "seiscientos",
    "setecientos",
    "ochocientos",
    "novecientos",
  ];

  const convertGroup = (n: number): string => {
    if (n === 0) return "";
    if (n === 100) return "cien";

    let str = "";
    const c = Math.floor(n / 100);
    const d = Math.floor((n % 100) / 10);
    const u = n % 10;

    if (c > 0) str += centenas[c] + " ";

    if (d === 1 && u < 10 && u >= 0) {
        // 10-19 handled specially if needed, but 'especiales' array covers 10-19
        // wait, my logic for 10-19:
        // 10 is diez, 11 once...
        // if d==1, we look at u.
        // n%100 is between 10 and 19.
        str += especiales[u] + " ";
        return str.trim();
    } else if (d === 2 && u > 0) {
        str += "veinti" + unidades[u] + " ";
        return str.trim();
    } else if (d > 0) {
        str += decenas[d];
        if (u > 0) str += " y " + unidades[u];
        str += " ";
    } else if (u > 0) {
        if (c === 0 && n === 1) return "uno"; 
        str += unidades[u] + " ";
    }
    return str.trim();
  };
  
  
  // Simplified implementation for < 1000000
  if (num >= 1000000) return num.toString(); 

  let words = "";

  const thousands = Math.floor(num / 1000);
  const remainder = num % 1000;

  if (thousands > 0) {
      if (thousands === 1) {
          words += "mil ";
      } else {
          words += convertGroup(thousands) + " mil ";
      }
  }

  if (remainder > 0) {
      words += convertGroup(remainder);
  }

  return words.trim();
};
